import { styled } from '@linaria/react';
import { fonts, semantic, size, space } from '../../theme/tokens';

export const StyledBadge = styled.span`
  display: inline-block;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  background: ${semantic.bg.urgencyStrong};
  color: ${semantic.text.inverse};
  padding: ${space['space-200']};
  border-radius: ${size.radius['radius-xs']};
  letter-spacing: normal;

  &[data-tone='neutral'] {
    background: ${semantic.bg.surfaceSubtle};
    color: ${semantic.text.secondary};
    padding: 2px ${space['space-200']};
    border-radius: ${size.radius['radius-md']};
    letter-spacing: normal;
  }

  &[data-tone='success'] {
    background: ${semantic.bg.positiveSubtle};
    color: ${semantic.text.positive};
    padding: ${space['space-100']} ${space['space-300']};
    border-radius: ${size.radius['radius-full']};
    font-weight: ${fonts.weight.medium};
    letter-spacing: normal;
  }
`;
